<template>
  <div class="operationchange">
    <el-dialog
      title="Production Change"
      :modelValue="modelValue"
      width="930px"
      @closed="CloseDialog"
    >
      <div>
        <el-form
          :model="ProductionChange"
          label-width="190px"
          label-position="right"
          ref="ruleFormRef"
          :disabled="OperationMode == 'view'"
        >
          <el-form-item label="Media">
            <base-input
              style="width: 100%"
              v-model="ProductionChange.mediaName"
              disabled
              placeholder="Media"
            >
            </base-input>
          </el-form-item>
          <el-form-item label="Quantity">
            <base-input
              style="width: 100%"
              v-model="ProductionChange.quantity"
              disabled
              placeholder="Quantity"
            ></base-input>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div>
                Production Date
                <span class="required-sign"> &nbsp;* </span>
              </div>
            </template>
            <base-input
              style="width: 100%"
              :class="{
                'has-error':
                  ProductionChange.validate &&
                  validation.isError(
                    ProductionChange.validate,
                    'productionDate'
                  ),
              }"
            >
              <el-date-picker
                v-model="ProductionChange.productionDate"
                style="border: 0px"
                type="date"
                placeholder="Production Date"
                value-format="YYYY-MM-DD"
                format="DD/MM/YYYY"
              ></el-date-picker>
            </base-input>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div>
                Production Cost Type
                <span class="required-sign"> &nbsp;* </span>
              </div>
            </template>
            <base-input
              style="background-color: #f5f5f5; width: 100%"
              :class="{
                'has-error':
                  ProductionChange.validate &&
                  validation.isError(
                    ProductionChange.validate,
                    'productionCostType'
                  ),
              }"
            >
              <el-select
                v-model="ProductionChange.productionCostType"
                placeholder="Production Cost Type"
                class="select-primary"
                :class="{ 'is-error': HighlineError('productionCostType') }"
              >
                <el-option
                  v-for="item in useInternalSplit.ProductionCostOptions"
                  class="select-primary"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </base-input>
          </el-form-item>
          <el-form-item>
            <template #label>
              <div>
                Unit Price By Sales
                <span
                  v-if="useAuthority.bHasRole('Salesman')"
                  class="required-sign"
                >
                  &nbsp;*
                </span>
              </div>
            </template>
            <base-input
              style="width: 100%"
              v-model="ProductionChange.salesAmount"
              :disabled="useAuthority.isOrderTop()"
              placeholder="Unit Price By Sales"
              @change="changeSalesAmount"
              class="input-money input-currency-noarea"
              :class="{
                'has-error':
                  useOperation.ProductionChange.validate &&
                  validation.isError(
                    useOperation.ProductionChange.validate,
                    'salesAmount'
                  ),
              }"
              ><template #addonLeft>
                <div class="currency">$</div>
              </template></base-input
            >
          </el-form-item>
          <el-form-item label="">
            <template #label>
              <div>
                Unit Price By Sales Admin
                <span class="required-sign"> &nbsp;* </span>
              </div>
            </template>
            <base-input
              style="width: 100%"
              v-model="ProductionChange.salesAdminAmount"
              :disabled="!useAuthority.isOrderTop()"
              placeholder="Unit Price By Sales Admin"
              class="input-money input-currency-noarea"
              :class="{
                'has-error':
                  useOperation.ProductionChange.validate &&
                  validation.isError(
                    useOperation.ProductionChange.validate,
                    'salesAdminAmount'
                  ),
              }"
              @change="changeSalesAdminAmount"
              ><template #addonLeft>
                <div class="currency">$</div>
              </template></base-input
            >
          </el-form-item>
          <el-form-item label="Remark">
            <base-input style="width: 100%">
              <el-input
                type="textarea"
                :rows="5"
                v-model="ProductionChange.remark"
              ></el-input>
            </base-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <base-button
          type="primary"
          @click="changeOperation"
          v-if="OperationMode != 'view'"
          >Save</base-button
        >
        <base-button @click="CloseDialog" v-if="OperationMode != 'view'"
          >Close</base-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
// vue
import { ref, onMounted } from 'vue';

import operationValidation from '@/views/contract/js/operationValidation';
import validation from '@/assets/js/validation';

// api
import { ElMessage, tagEmits } from 'element-plus';
import { useContractStore } from '@/store/contract';
import { useOperationStore } from '@/store/operation';
import { useInternalSplitStore } from '@/store/internalsplit';
import { useAuthorityStore } from '@/store/authority';

import { storeToRefs } from 'pinia';

const useAuthority = useAuthorityStore();

// useContract
const useContract = useContractStore();

// useOperation
const useOperation = useOperationStore();
const { ProductionChange, OperationMode } = storeToRefs(useOperation);

// useInternalSplit
const useInternalSplit = useInternalSplitStore();

defineProps(['modelValue']);
const emits = defineEmits(['update:modelValue']);

// 验证
const errors = ref([]);

onMounted(() => {
  console.log('open');
});

const changeSalesAmount = async () => {
  ProductionChange.value.salesAdminAmount = ProductionChange.value.salesAmount;

  await useOperation.validate('prodchange');
  var message = '';
  if (!parseFloat(ProductionChange.value.salesAdminAmount) === 0) {
    message =
      ProductionChange.value.validate.find((t) => t.field === 'salesAmount')
        ?.message || '';
  }

  if (message !== '') {
    ElMessage({
      message,
      type: 'warning',
    });

    ProductionChange.value.salesAmount = 0;
  }

  ProductionChange.value.salesAdminAmount = ProductionChange.value.salesAmount;
};

const changeSalesAdminAmount = async () => {
  if (ProductionChange.value.salesAdminAmount !== '') {
    await useOperation.validate('prodchange');

    var message = '';
    if (!(parseFloat(ProductionChange.value.salesAdminAmount) === 0)) {
      message =
        ProductionChange.value.validate.find(
          (t) => t.field === 'salesAdminAmount'
        )?.message || '';
    }

    if (message !== '') {
      ElMessage({
        message,
        type: 'warning',
      });

      ProductionChange.value.salesAdminAmount = 0;
    }
  }
};

const changeOperation = async () => {
  const messageConfig = require('@/models/messageConfig');

  const _OperationSummary = useOperation.OperationSummaryDetails.find(
    (t) => t.id === ProductionChange.value.id
  );
  const remainingBalance =
    parseFloat(useOperation.OperationSummary.remainingBalanceAmount) +
    parseFloat(_OperationSummary?.salesAdminAmount || 0);

  ProductionChange.value.remainingBalance = remainingBalance;

  await useOperation.validate('prodchange', undefined, 'save');

  Reflect.deleteProperty(ProductionChange.value, 'action');
  Reflect.deleteProperty(ProductionChange.value, 'remainingBalance');

  var message = useOperation.ProductionChange.validate?.[0]?.message || '';

  if (message === '') {
    message = await useOperation.UpdateProductionChange().then((res) => res);
  }

  if (message !== '') {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  CloseDialog();

  ElMessage({
    message: messageConfig.getMessage('productionChange'),
    type: 'success',
  });
};
// #endregion

// 关闭窗口
const CloseDialog = () => {
  useOperation.ProductionChange = {};

  emits('update:modelValue', false);
};

// 高亮显示
const HighlineError = (field) => {
  return errors.value?.filter((t) => t.field === field)?.length > 0;
};
</script>

<style scoped>
.operationchange .el-form-item .el-select {
  width: 100%;
}
</style>
